export const getChildParam = <T = string>(item: any, param: string): T | string => {
    const target = param.split('.');
    const controlsGroup = target.reduce((previsionItems: (string | number)[], item: string) => {
        if (item.indexOf('[') > 0) {
            const sliceItem = item.slice(item.indexOf('[') + 1, item.indexOf(']'));

            return previsionItems.concat([item.split(`[${sliceItem}]`)[0]]).concat([Number(sliceItem)]);
        }

        return previsionItems.concat([item]);
    }, []);
    if (controlsGroup?.length > 1) {
        const resultString = controlsGroup.join('.');
        const sliceParam = resultString.slice(resultString.indexOf('.') + 1, param.length);

        return item[controlsGroup[0]] ? getChildParam<T>(item[controlsGroup[0]], sliceParam) : '';
    } else {
        return item[controlsGroup[0]];
    }
};
